import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { disableNigelScheduleTag, enableNigelScheduleTag, getNigelScheduleTagStatus } from "../../../services/aws/ec2";

/**
 * Component for managing Nigel schedule tag in the admin interface.
 *
 * @component
 * @example
 * return (
 *   <NigelScheduleTag />
 * )
 *
 * @returns {JSX.Element} Grid containing Nigel schedule tag cards for different services
 */
function NigelScheduleTag() {
  const [nigelScheduleTagActive, setNigelScheduleTagActive] = useState(false);

  useEffect(() => {
    fetchStatus();
  }, []);

  /**
   * Fetch current nigel schedule tag status
   */
  const fetchStatus = async () => {
    try {
      const response = await getNigelScheduleTagStatus();
      const jsonResponse = await response.json();

      // If both nigel and metabase schedule tags are active, set the state to true
      setNigelScheduleTagActive(
        jsonResponse.data.nigel.tag_value === "nigel-schedule" &&
          jsonResponse.data.metabase.tag_value === "nigel-schedule"
      );

    } catch (error) {
      console.error("Failed to fetch nigel schedule tag status:", error);
    }
  };

  /**
   * Enable nigel schedule tag
   */
  const handleEnableNigelScheduleTag = async () => {
    try {
      const response = await enableNigelScheduleTag();
      const jsonResponse = await response.json();
      if (jsonResponse && jsonResponse.success) {
        fetchStatus();
      }
    } catch (error) {
      console.error("Failed to enable nigel schedule tag:", error);
    }
  };

  /**
   * Disable nigel schedule tag
   */
  const handleDisableNigelScheduleTag = async () => {
    try {
      const response = await disableNigelScheduleTag();
      const jsonResponse = await response.json();
      if (jsonResponse && jsonResponse.success) {
        fetchStatus();
      }
    } catch (error) {
      console.error("Failed to disable nigel schedule tag:", error);
    }
  };

  return (
    <Card sx={{ width: "100%" }}>
      <CardContent>
        <Typography variant="h6" component="div" sx={{ m: 2 }}>
          Status: {nigelScheduleTagActive ? "ENABLED" : "DISABLED"}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, m: 2 }}>
          <Button
            variant="contained"
            color="primary"
            disabled={nigelScheduleTagActive}
            onClick={handleEnableNigelScheduleTag}
          >
            Enable Nigel Schedule Tag
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={!nigelScheduleTagActive}
            onClick={handleDisableNigelScheduleTag}
          >
            Disable Nigel Schedule Tag
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default NigelScheduleTag;
